module.exports = __webpack_public_path__ + "static/media/mistletoe.fb9c520d.svg";